import type { PushAction } from "../data"
import NoteText from "./NoteText"

export interface Mention {
  fromSku: string
  action: PushAction
}

// Actions on other products (or their batches) that name this one with #SKU.
export default function MentionedBy({ mentions }: { mentions: Mention[] }) {
  return mentions.map((m) => (
    <div key={m.action.id} className="mt-2 text-sm">
      Named in an action for <NoteText note={`#${m.fromSku}`} />: <span className="font-semibold">{m.action.type}</span> · <NoteText note={m.action.note} />
    </div>
  ))
}
